// extracted by mini-css-extract-plugin
module.exports = {"content":"ShopBase_content__Yl4j3"};